<template>
    <div>

    </div>
</template>

<script>
    export default {
        props: ['txnId'],
        created() {
            airtime_checkout(this.txnId);
            $('div.close').trigger('click');
            $('#airtime_form')
                    .css('width','100%')
                    .css('height','480px');
            $('#airtime_form div').css('width','809px').css('height','480px').css('margin','0 auto');
            $('#airtime_iframe').css('width','100%').css('height','480px');
            $('a.close').append("<div id='off' style='position: fixed; right: 555px; width: 16px; height: 17px; background-color: #ffffff; z-index: 999999; margin-right: 3px; margin-top: 2px;' @click='off'><i class='el-icon-close' style='cursor: pointer'></i></div>");
            $('#exposeMask').css('background-color','rgb(0,0,0)');
        },
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .off{

    }
</style>


// WEBPACK FOOTER //
// RechargeByJsLoad.vue?6631c973